function svgToDataUri(svg: string): string {
  return `data:image/svg+xml;base64,${btoa(
    encodeURIComponent(svg).replace(/%([0-9A-F]{2})/g, (_, hex: string) => String.fromCharCode(parseInt(hex, 16)))
  )}`;
}

function arrowUp(color: string): string {
  return svgToDataUri(
    `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 7"><path stroke="${color}" stroke-linecap="round" stroke-linejoin="round" d="M3 6.5v-6M5.5 3 3 .5.5 3"/></svg>`
  );
}

function arrowDown(color: string): string {
  return svgToDataUri(
    `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 7"><path stroke="${color}" stroke-linecap="round" stroke-linejoin="round" d="M3 .5v6M.5 4 3 6.5 5.5 4"/></svg>`
  );
}

export const arrowAssets = {
  ahead: arrowUp('#004D73'),
  behind: arrowDown('#614700'),
} as const;
